import { APP_LOCAL_DATE_FORMAT } from "@/config/constants";
import { IEdoFile } from "@/shared/model/edo-file.model";
import { getFileAvatar } from "@/shared/util/file-avatar-utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@/components/ui";
import { Download, MoreVertical, Pencil, Trash2 } from "lucide-react";
import "moment/locale/it";
import React from "react";
import { TextFormat } from "react-jhipster";

interface IEdoFileRowProps {
  file: IEdoFile;
  onEdit: (file: IEdoFile) => void;
  onDelete: (file: IEdoFile) => void;
}

const FileRow = (props: IEdoFileRowProps) => {
  const { file, onEdit: handleEdit, onDelete: handleDelete } = props;

  const openFile = (f: IEdoFile) => {
    window.open(`/api/files/${f.id}/view`, "_blank");
  };

  const downloadFile = (f: IEdoFile) => {
    window.open(`/api/files/${f.id}/download`, "_blank");
  };

  return (
    <ListItem
      className="flex cursor-pointer items-center gap-3 px-5 py-3.5 transition-colors hover:bg-primary/5"
      onClick={() => openFile(file)}
    >
      <ListItemIcon className="shrink-0">
        {getFileAvatar(file.fileType)}
      </ListItemIcon>
      <ListItemText
        primary={
          <span className="text-sm font-semibold text-[var(--color-mockup-text)]">
            {file.originalFileName}
          </span>
        }
        secondary={
          <span className="text-xs text-[var(--color-mockup-text-light)]">
            <TextFormat
              value={file.createdAt}
              type="date"
              format={APP_LOCAL_DATE_FORMAT}
            />
          </span>
        }
        className="min-w-0 flex-1"
      />
      <ListItemSecondaryAction className="ml-2 shrink-0" onClick={(e) => e.stopPropagation()}>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <IconButton aria-label="Azioni file" className="w-8 h-8 rounded-full text-[var(--color-mockup-text-light)] hover:text-[var(--color-mockup-text)] hover:bg-[var(--color-mockup-border)]/50">
              <MoreVertical className="h-4 w-4" />
            </IconButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => handleEdit(file)}>
              <Pencil className="mr-2 h-4 w-4" />
              Rinomina file
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => downloadFile(file)}>
              <Download className="mr-2 h-4 w-4" />
              Download file
            </DropdownMenuItem>
            <DropdownMenuItem
              onClick={() => handleDelete(file)}
              className="text-[var(--color-mockup-coral)] focus:text-[var(--color-mockup-coral)]"
            >
              <Trash2 className="mr-2 h-4 w-4" />
              Elimina file
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

export default FileRow;
